import { createFileRoute } from "@tanstack/react-router";

import { MySkills } from "@/components/my-skills";

export const Route = createFileRoute("/_authed/skills")({
  component: MySkills,
});
